<template>
  <div class="my-loading-container" v-loading="loading"></div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.my-loading-container {
  height: 20vh;
}
</style>
